module.exports={PASSPORT:"Pasaporte",NATIONAL_ID_CARD:"DNI, NIE o OTRO DOCUMENTO"};